

















































import Vue from "vue";
export default Vue.extend({
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    disable: {
      type: Boolean,
      default: false,
    },
    left: {
      type: String,
      required: true,
    },
    right: {
      type: String,
      required: true,
    },
  },
  setup(props, { emit }) {
    const onToggle = () => {
      if (!props.disable) {
        emit("input", !props.value);
      }
    };
    return {
      onToggle,
    };
  },
});
